import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { MeasurementFilter } from 'schemas/MeasurementFilterSchema'
import MeasurementType from 'enums/MeasurementType'
import { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'
import { resolveValueFromMetric } from '../utils/surveyScoresUtil'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  surveyScores: [
    ...(filter.surveyScores || []),
    {
      type: MeasurementType.SURVEY,
      overallChecked: true,
      values: resolveValueFromMetric(insights[0].name! as MetricCategoryItemStrings)
    } as MeasurementFilter
  ]
})

const generateSurveyScoresInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateSurveyScoresInsightStrategy
